import { Block } from '@/core/Block.js'
import { Scroll } from '@/components/VScroll.js'
import { Sleep } from '@/utils/Sleep'

export class Carousels_2 extends Block {
  async init() {
    super.init()

    this.mobile = this.el.dataset.horizontalScrollMobile === undefined
    this.items = this.el.querySelectorAll('[data-carousel-item]')
    this.infinite = true

    this.container = this.get('[data-carousel]')

    // fill container with at least 20 items


    if (this.items.length < 20 && this.items.length > 0) {
      const itemsNeeded = 20 - this.items.length;
      for (let i = 0; i < itemsNeeded; i++) {
        const itemToClone = this.items[i % this.items.length];
        this.container.appendChild(itemToClone.cloneNode(true));
      }
    }

    this.carouselInstance = new Scroll({
      selector: this.container,
      page: this.el,
      container: this.container,
      selectorChild: '[data-carousel-item]',
      selectorGroup: '[data-carousel-items]',
      horizontal: true,
      infinite: this.infinite,
      propagation: true,
      scrollY: false,
      scrollX: false,
      drag: false,
      smooth: true,
      scrollBar: false,
      autoScroll: true,
    })

    // bind events
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  async addEvents() {
    super.addEvents()

    await Sleep(1000)

    this.carouselInstance.onResize()
    this.carouselInstance.activate()

    // add hover event listener to this.container
    this.container.addEventListener('mouseenter', this.onMouseEnter)
    this.container.addEventListener('mouseleave', this.onMouseLeave)
  }

  destroy() {
    this.carouselInstance?.destroy()

    this.container.removeEventListener('mouseenter', this.onMouseEnter)
    this.container.removeEventListener('mouseleave', this.onMouseLeave)

    super.destroy()
  }

  onMouseEnter() {
    // this.carouselInstance.options.autoScroll = false
  }

  onMouseLeave() {
    // this.carouselInstance.options.autoScroll = true
  }
}
